import { useEffect } from 'react'
import { BACKEND_BASE_URL } from 'app/constants'
import { isUserAccessDeniedVar } from 'shared/store/user'
import { UserMetadata } from 'shared/types'

export const useUserMetadata = () => {
  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(`${BACKEND_BASE_URL}/api/user-metadata`)
        if (!res.ok) return
        const metadata = (await res.json()) as UserMetadata
        const isAccessDenied = RESTRICTED_COUNTRIES.includes(
          metadata['cf-ipcountry']
        )
        if (isAccessDenied) {
          isUserAccessDeniedVar(true)
        }
      } catch {
        // Local dev: wrong host/protocol or API unavailable
      }
    }
    void load()
  }, [])
}

const RESTRICTED_COUNTRIES = ['US']
